import React from 'react'

import clsx from 'clsx'

import Listing from 'components/Listing'
import Skeleton from 'components/Skeleton'

import classes from './ListingSkeleton.module.scss'

const ListingSkeleton = props => {
  return (
    <Listing.Card className={clsx('ListingSkeleton', classes.container)} {...props}>
      <div className={classes.top}>
        <Skeleton width={72} height={72} variant="rect" className={classes.avatar} />
        <div>
          <Skeleton height={24} width={160} variant="rect" className={classes.name} />
          <Skeleton height={16} width={100} variant="rect" className={classes.rate} />
          <Skeleton height={16} width={230} variant="rect" className={classes.description} />
        </div>
      </div>
      <Skeleton height={100} width="100%" variant="rect" className={classes.text} />
      <Skeleton height={26} width={260} variant="rect" className={classes.more} />
    </Listing.Card>
  )
}

export default ListingSkeleton
